import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Box
} from '@mui/material';

const Navigation = ({ currentKey, onGoTo, currentIndex = 0, totalDocuments = 0 }) => {
  const steps = [
    { key: 'start', label: 'Start' },
    { key: 'fields', label: 'Fields' },
    {
      key: 'annotate',
      label: totalDocuments > 0
        ? `Annotate ${currentIndex + 1}/${totalDocuments}`
        : 'Annotate'
    },
    { key: 'review', label: <>Review<br />& reorder</> },
    { key: 'generate', label: <>Generate</> }
  ];

  const activeStep = steps.findIndex(step => step.key === currentKey);

  return (
    <Box sx={{ width: '100%', my: 2 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((step, index) => {
          const isDisabled = index === 5 || index === 6; // Step 6 and 7
          return (
            <Step key={step.key}>
              <StepLabel
                onClick={!isDisabled ? () => onGoTo(step.key) : undefined}
                sx={{ cursor: isDisabled ? 'default' : 'pointer' }}
              >
                {step.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default Navigation;
